module.exports = __webpack_public_path__ + "static/ades.9cc9325d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/ades.jpg
// module id = 781
// module chunks = 219805994829571